import { render } from "./AftercareV2.vue?vue&type=template&id=dff4fdc6&scoped=true"
import script from "./AftercareV2.vue?vue&type=script&lang=js"
export * from "./AftercareV2.vue?vue&type=script&lang=js"

import "./AftercareV2.vue?vue&type=style&index=0&id=dff4fdc6&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dff4fdc6"]])

export default __exports__